import React from "react";
import { useSearchParams } from "react-router-dom";
import Spacing from "../Spacing";
import SectionHeadingStyle3 from "../SectionHeading/SectionHeadingStyle3";
import { Icon } from "@iconify/react";
import { pageTitle } from "../../helpers/PageTitle";

export default function PortfolioDetailsPage() {
  const [searchParams] = useSearchParams();
  const courtType = searchParams.get('type') || 'padel';
  const courtNumber = searchParams.get('court') || '1';

  // Court data based on type and court number
  const courtData = {
    padel: {
      1: {
        title: "Padel Court 01",
        subTitle: "Padel Court Details", 
        mainImage: "/images/creative-agency/004.jpg",
        price: "PKR 7,500 per hour",
        availability: "7 AM - 7 PM Daily",
        description: "Step onto our state-of-the-art Padel Court 1, built to international standards for players of all skill levels. Whether you're a beginner or a pro, our courts offer the perfect surface and ambiance for high-energy matches, training sessions, or casual games with friends.",
        gallery: [
          "/images/creative-agency/player1.png",
          "/images/creative-agency/004.jpg", 
          "/images/creative-agency/portfolio_2.jpeg"
        ],
        features: [
          "Professional Grade Synthetic Turf",
          "International Standard Dimensions",
          "LED Lighting System",
          "Spectator Seating Area"
        ]
      },
      2: {
        title: "Padel Court 02",
        subTitle: "Padel Court Details",
        mainImage: "/images/creative-agency/padelcourt2.jpeg",
        price: "PKR 7,500 per hour",
        availability: "7 AM - 7 PM Daily",
        description: "Experience the thrill of Padel on our premium Court 2. Perfect for competitive matches and training sessions. Our court features high-quality surface that provides excellent ball control and player safety.",
        gallery: [
          "/images/creative-agency/004.jpg",
          "/images/creative-agency/padelcourt2.jpeg",
          "/images/creative-agency/padelcourt2.jpeg"
        ],
        features: [
          "Premium Padel Surface",
          "Professional Dimensions",
          "Advanced Lighting",
          "Comfortable Viewing Area"
        ]
      },
      3: {
        title: "Padel Court 03",
        subTitle: "Padel Court Details",
        mainImage: "/images/creative-agency/padelcourt3.jpeg",
        price: "PKR 7,500 per hour",
        availability: "7 AM - 7 PM Daily",
        description: "Padel Court 3 offers an exceptional playing experience with its state-of-the-art facilities. Ideal for both recreational play and professional training sessions.",
        gallery: [
          "/images/creative-agency/padelcourt3.jpeg",
          "/images/creative-agency/padelcourt3.jpeg",
          "/images/creative-agency/portfolio_2.jpeg"
        ],
        features: [
          "High-Quality Playing Surface",
          "Standard Padel Dimensions",
          "Professional Lighting",
          "Spectator Facilities"
        ]
      },
      4: {
        title: "Padel Court 04",
        subTitle: "Padel Court Details",
        mainImage: "/images/creative-agency/padel4.jpeg",
        price: "PKR 7,500 per hour",
        availability: "7 AM - 7 PM Daily",
        description: "Padel Court 4 is designed for the ultimate padel experience. With premium facilities and perfect playing conditions, it's the ideal venue for serious players and tournaments.",
        gallery: [
          "/images/creative-agency/portfolio_1.jpeg",
          "/images/creative-agency/padel4.jpeg",
          "/images/creative-agency/portfolio_2.jpeg"
        ],
        features: [
          "Tournament-Grade Surface",
          "Professional Court Dimensions",
          "Advanced LED Lighting", 
          "Premium Spectator Area"
        ]
      }
    },
    Futsal: {
      1: {
        title: "Futsal Court 1",
        subTitle: "Futsal Court Details", 
        mainImage: "/images/creative-agency/whyx.png",
        price: "PKR 6,500 per hour",
        availability: "6 AM - 8 PM Daily",
        description: "Experience the thrill of Futsal on our premium Futsal Court 1. Perfect for 5-a-side matches, training sessions, and competitive leagues. Our court features high-quality artificial turf that provides excellent ball control and player safety.",
        gallery: [
          "/images/creative-agency/whyx.png",
          "/images/creative-agency/portfolio_6.jpg",
          "/images/creative-agency/Futsal.png"
        ],
        features: [
          "Premium Artificial Turf",
          "FIFA Standard Dimensions",
          "Professional Goal Posts",
          "Floodlight System"
        ]
      },
      2: {
        title: "Futsal Court 2",
        subTitle: "Futsal Court Details", 
        mainImage: "/images/creative-agency/portfolio_6.jpg",
        price: "PKR 6,500 per hour",
        availability: "6 AM - 8 PM Daily",
        description: "Futsal Court 2 offers an exceptional futsal experience with professional-grade facilities. Perfect for competitive matches and training sessions with excellent playing conditions.",
        gallery: [
          "/images/creative-agency/portfolio_6.jpg",
          "/images/creative-agency/Futsal.png",
          "/images/creative-agency/whyx.png"
        ],
        features: [
          "Professional Futsal Surface",
          "International Dimensions",
          "Quality Goal Posts",
          "Professional Lighting"
        ]
      }
    },
    multipurpose: {
      1: {
        title: "Multi-Purpose Court 1",
        subTitle: "Multi-Purpose Court Details",
        mainImage: "/images/creative-agency/multi.png", 
        price: "PKR 5,500 per hour",
        availability: "6 AM - 9 PM Daily",
        description: "Our versatile Multi-Purpose Court 1 is designed to accommodate Multi Purpose, volleyball, throwball, and other sports. With flexible markings and adjustable equipment, this court serves multiple sporting needs in one premium facility.",
        gallery: [
          "/images/creative-agency/multi.png",
          "/images/creative-agency/portfolio_2.jpeg",
          "/images/creative-agency/portfolio_1.jpeg"
        ],
        features: [
          "Versatile Playing Surface",
          "Adjustable Equipment",
          "Multiple Sport Markings",
          "Flexible Booking Options"
        ]
      }
    }
  };

  const currentCourt = courtData[courtType]?.[courtNumber] || courtData.padel[1];
  pageTitle(currentCourt.title);

  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3 title={currentCourt.title} subTitle={currentCourt.subTitle} />
      <Spacing lg="75" md="60" />
      <div className="container">
        <div className="cs_portfolio_details">
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            width: '100%',
            marginBottom: '20px'
          }}>
            <img 
              src={currentCourt.mainImage} 
              alt="Court" 
              style={{
                maxWidth: '100%',
                height: 'auto',
                borderRadius: '15px'
              }}
            />
          </div>
          <Spacing lg="100" md="40" />
          <div className="cs_portfolio_details_in">
            <ul className="cs_portfolio_details_info cs_mp0">
              {/* <li>
                <h3 className="cs_fs_21 mb-0 cs_semibold">Court Type:</h3>
                <p className="mb-0">{currentCourt.title}</p>
              </li> */}
              <li>
                <h3 className="cs_fs_21 mb-0 cs_semibold">Price:</h3>
                <p className="mb-0">{currentCourt.price}</p>
              </li>
              <li>
                <h3 className="cs_fs_21 mb-0 cs_semibold">Availability:</h3>
                <p className="mb-0">{currentCourt.availability}</p>
              </li>
              {/* <li>
                <h3 className="cs_fs_21 mb-0 cs_semibold">Features:</h3>
                <ul className="mb-0">
                  {currentCourt.features.map((feature, index) => (
                    <li key={index} style={{ marginLeft: '20px', listStyle: 'disc' }}>
                      {feature}
                    </li>
                  ))}
                </ul>
              </li> */}
            </ul>
            <div className="cs_portfolio_details_right">
              <h2>{currentCourt.title} at Ignite Sports Pavilion</h2>
              <p>{currentCourt.description}</p>
            </div>
          </div>
          <Spacing lg="115" md="60" />
          <div className="cs_portfolio_details_gallery">
            {currentCourt.gallery.map((image, index) => (
              <div key={index}>
                <img src={image} alt={`${currentCourt.title} View ${index + 1}`} />
            </div>
            ))}
          </div>
        </div>
        <Spacing lg="90" md="60" />
      </div>
      <Spacing lg="150" md="80" />
    </>
  );
}
